import axios from 'axios';
import config from '../config/config';

// Convert wp-admin/ to wp-json/wp/v2 for REST API
const getApiBaseUrl = (): string => {
  const baseUrl = config.API_BASE_URL;
  // Replace /wp-admin/ with /wp-json/wp/v2
  if (baseUrl.endsWith('/wp-admin/')) {
    return baseUrl.replace('/wp-admin/', '/wp-json/wp/v2');
  }
  // If it doesn't end with /wp-admin/, assume it's the base URL and append wp-json/wp/v2
  const cleanUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  return `${cleanUrl}/wp-json/wp/v2`;
};

// Create axios instance with base configuration
const apiBase = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Request interceptor (optional - for adding auth tokens, etc.)
apiBase.interceptors.request.use(
  (config) => {
    // You can add authentication tokens here if needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor (optional - for handling errors globally)
apiBase.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors here
    if (error.response) {
      console.error('API Error:', error.response.status, error.response.data);
    } else if (error.request) {
      console.warn('Network unavailable — could not reach the API server. Check your connection or server status.');
    } else {
      console.error('Request Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiBase;

